import { userProfileConstants } from '../../_constants';

const initialState = {setPasswordLoad: false, setPasswordData: {}, setPasswordError: false}

export function setPasswordReducerMain(state = initialState, action) {
  switch (action.type) {
    case userProfileConstants.REQUEST_SET_PASSWORD:
      return {
        setPasswordLoad: true,
        setPasswordData: {},
        setPasswordError: false
      };
    case userProfileConstants.RECEIVE_SET_PASSWORD:
      return {
        setPasswordLoad: false,
        setPasswordData: action.setPassword.data,
        setPasswordError: false
      };
    case userProfileConstants.SET_PASSWORD_ERROR:
      return {
        setPasswordLoad: false,
        setPasswordData: {},
        setPasswordError: true
      };
    default:
      return state
  }
}


// WEBPACK FOOTER //
// ./src/_reducers/set-password/set-password.reducer.js